import CryptoJS from 'crypto-es';

import { EStorageKey } from '../storage';
import { ICipher } from './types';

const SP_NORMAL = 'secretPassNormal';
const SP_TOKEN = 'secretPassToken';
const SP_USER_ID = 'secretPassUserId';
const SP_PASSWORD = 'secretPassPassword';

class Cipher implements ICipher {
  encrypt(key: EStorageKey, value: string) {
    try {
      const data = CryptoJS.AES.encrypt(JSON.stringify(value), this.getSecretPass(key)).toString();
      return data ? data : undefined;
    } catch (e) {
      return undefined;
    }
  }

  decrypt(key: EStorageKey, value: string) {
    try {
      const bytes = CryptoJS.AES.decrypt(value, this.getSecretPass(key));
      const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      return data ? data : undefined;
    } catch (e) {
      return undefined;
    }
  }

  private getSecretPass(key: EStorageKey) {
    switch (key) {
      case EStorageKey.TOKEN:
        return SP_TOKEN;
      case EStorageKey.USER_ID:
        return SP_USER_ID;
      case EStorageKey.PASSWORD:
        return SP_PASSWORD;
      default:
        return SP_NORMAL;
    }
  }
}

export default new Cipher();
